import axios from "axios";
import type { FailedCheckColor } from "../utils/checkFormat";

export interface Check {
  id?: string;
  code?: string;
  description?: string;
  responsibility?: string;
  active?: boolean;
  successText?: string;
  failText?: string;
  suggestion?: string;
  failedCheckColor?: FailedCheckColor;
  warnCheckColor?: string;
}

export const fetchCheckList = (): Promise<Check[]> =>
  axios.get("/check").then((resp) => (Array.isArray(resp.data) ? resp.data : []));

export const fetchCheckById = (id: string): Promise<Check> =>
  axios.get(`/check/${id}`).then((resp) => resp.data);

export const createCheck = (data: Check): Promise<Check> =>
  axios.post("/check", data).then((resp) => resp.data);

export const updateCheck = (id: string, data: Check): Promise<Check> =>
  axios.put(`/check/${id}`, data).then((resp) => resp.data);
